import { Component, OnInit, Inject } from '@angular/core';
import { apiService } from '../../../../../service/api.service';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { AutoevaluacionModel } from '../../../../../model/Etapas.model'

@Component({
  selector: 'app-modal-resumen-medios-verificacion',
  templateUrl: './modal-resumen-medios-verificacion.component.html',
  styleUrls: ['./modal-resumen-medios-verificacion.component.css']
})
export class ModalResumenMediosVerificacionComponent implements OnInit {

  autoEvaluacion = new Array<AutoevaluacionModel>();
  nMedios = 0;
  constructor(
    public dialogRef: MatDialogRef<ModalResumenMediosVerificacionComponent>,
    public api:apiService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    this.autoEvaluacion = this.data;

  }

  descargarMedio(id){
    console.log(id)
    this.api.API_POST_descargarMediosVerificacion(id).subscribe((response) => {
      var save = document.createElement('a');   
      save.href = "data:"+response.payload.mime+";base64,"+response.payload.base
      save.target = '_blank';
      save.download = response.payload.nombre || 'archivo.dat';
      var clicEvent = new MouseEvent('click', {
          'view': window,
              'bubbles': true,
              'cancelable': true
      });
      save.dispatchEvent(clicEvent);
      (window.URL || window.webkitURL).revokeObjectURL(save.href);
    },
    (err) => {
      console.log(err)
    })
  }
  onNoClick(){
    this.dialogRef.close();
  }
 
}
